import { axiosGeoClient } from './client';

export const ipToLocation = async (ip?: string) => {
  if (!ip) return null;

  const {
    data: { city_name: city, country_name: country, country_iso_code: countryIsoCode, subdivision_2_name: subdivision },
  } = await axiosGeoClient.get(`/geo?ip=${ip}`);
  const locationParts: string[] = [];

  if (city) locationParts.push(city);
  if (country) locationParts.push(country);
  if (countryIsoCode) locationParts.push(countryIsoCode);
  if (subdivision) locationParts.push(subdivision);

  return locationParts.join(', ');
};
